module.exports = __webpack_public_path__ + "static/img/down-zh.f1925ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/down-zh.jpg
// module id = o5sG
// module chunks = 2